import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
export default class AccessorialRatesPercentOfTariffEditor extends React.Component {
    handlePersentChange() {
        return (e) => {
            const persent = Number(e.target.value);
            this.props.onChange('percent', persent);
            const description = `${persent}% of tariff rate`;
            this.props.onChange('description', description);
        };
    }
    validateValue(persent) {
        if (persent >= 0 && persent <= 100) {
            return '';
        }
        return 'error';
    }
    render() {
        const accessorialRate = this.props.accessorialRate || {};
        return (React.createElement(Grid, { fluid: true },
            React.createElement(Row, { className: "show-grid" },
                React.createElement(Col, { xs: 4 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, accessorialRate.name),
                        React.createElement(FormControl, { type: "number", defaultValue: accessorialRate.percent, onChange: this.handlePersentChange(), bsStyle: this.validateValue(accessorialRate.percent) }))),
                React.createElement(Col, { xs: 4 },
                    React.createElement("div", { calssName: "form-group", style: { marginTop: 30 } },
                        React.createElement("label", null, "% of tariff rate"))))));
    }
}
AccessorialRatesPercentOfTariffEditor.propTypes = {
    accessorialRate: PropTypes.object,
    onChange: PropTypes.func,
};
